import { isFuture, isPast, subDays } from 'date-fns';
import { SortResult, SortedDocs } from './types';
import { partition } from 'lodash';
import { DocType, PilotDoc } from '../../../types';
import { sortDocsByDate } from '../../../libs/sortDocsByDate';
import { P107_NOTIFY_IN_DAYS } from '../config';

export function filterAndSortP107(docs: PilotDoc[]): SortResult {
  const processedP107: SortedDocs = {
    good: [],
    needAttention: [],
  };

  // if there is no document of type, return missedDocTypes and stop
  if (docs.length === 0) {
    return { ...processedP107, missedDocTypes: DocType.REMOTE_PILOT_CERTIFICATE };
  }

  const [futureDocs, restDocs] = partition(docs, (d) => d.startDate && isFuture(d.startDate));

  // all future documents should be in good section
  processedP107.good.push(...futureDocs);

  // if there are no current or expired documents, return future documents, missedDocTypes and stop
  if (restDocs.length === 0) {
    return { ...processedP107, missedDocTypes: DocType.REMOTE_PILOT_CERTIFICATE };
  }

  // Note! there could be several current documents, but this case is not covered, since it is rather the data issue
  // Note! all of the rest (past and probably other current documents will be dropped, even if they marked as 'Fix requested')
  const currentDoc = restDocs.find((d) => d.startDate && isPast(d.startDate) && d.endDate && isFuture(d.endDate));

  // if there is a current document, check the expiration period, place it to the proper section, return (current and future) and stop
  if (currentDoc && currentDoc.endDate) {
    const willExpireSoon = isPast(subDays(currentDoc.endDate, P107_NOTIFY_IN_DAYS));

    if (willExpireSoon) {
      processedP107.needAttention.push(currentDoc);
    } else {
      processedP107.good.push(currentDoc);
    }

    return processedP107;
  }

  // Here there could be only expired documents. Sort them and get one with the latest end date
  const sortedExpiredDocs = sortDocsByDate(restDocs);
  const theLatestExpiredDoc = sortedExpiredDocs[0];

  processedP107.needAttention.push(theLatestExpiredDoc);

  return processedP107;
}
